import * as yup from "yup";

import { PuntoGeograficoSchema } from "./PuntoGeograficoSchema";
import { CodigoPostalRegex } from "../utils/regex";

export const DireccionSchema = yup.object().shape({
  calle: yup
    .string()
    .required("errors.direccion.calle.required")
    .max(70, "errors.direccion.calle.max"),
  altura: yup
    .string()
    .required("errors.direccion.altura.required")
    .max(7, "errors.direccion.altura.max"),
  unidadFuncional: yup
    .string()
    .transform((value, originalValue) => {
      return value === "" ? null : value;
    })
    .max(20, "errors.direccion.unidadFuncional.max")
    .optional()
    .nullable(),
  provincia: yup
    .object()
    .typeError("errors.direccion.provincia.type")
    .required("errors.direccion.provincia.required"),
  departamento: yup
    .object()
    .typeError("errors.direccion.departamento.type")
    .required("errors.direccion.departamento.required"),
  localidad: yup
    .object()
    .typeError("errors.direccion.localidad.type")
    .required("errors.direccion.localidad.required"),
  codigoPostal: yup
    .string()
    .required("errors.direccion.codigoPostal.required")
    .min(4, "errors.direccion.codigoPostal.min")
    .max(8, "errors.direccion.codigoPostal.max")
    .matches(CodigoPostalRegex, "errors.direccion.codigoPostal.regex")
    .default(""),
  normalizada: yup
    .number()
    .required("errors.direccion.normalizada.required")
    .default(false),
  ubicacion: PuntoGeograficoSchema.optional().nullable().default(null),
});
